import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {DashboardModel} from "../models/dashboard.model";

export class DashboardsRequestsService {
  constructor(private dashboardsAPI: BringozApi, private $dashboards) {
  }

  createDashboard(dashboard: DashboardModel) {
    const api = this.dashboardsAPI.actions.createDashboard;
    return this.$$call(api, {}, dashboard, {});
  }

  updateDashboard(dashboard: DashboardModel) {
    const api = this.dashboardsAPI.actions.updateDashboard;
    return this.$$call(api, {}, dashboard, {id: dashboard.id});
  }

  deleteDashboard(dashboardId: string) {
    const api = this.dashboardsAPI.actions.deleteDashboard;
    return this.$$call(api, {}, {}, {id: dashboardId});
  }

  getDashboardById(dashboardId: string) {
    const api = this.dashboardsAPI.actions.getDashboard;
    return this.$$call(api, {}, {}, {id: dashboardId});
  }

  getConfigurations() {
    const api = this.dashboardsAPI.actions.getConfigurations;
    return this.$$call(api, {}, {}, {});
  }

  getDashboardWidgetData(datasource, queryParams) {
    const api = this.dashboardsAPI.actions.getDashboardWidgetData;
    return this.$$call(api, queryParams, {}, {datasource: datasource});
  }

  getDashboardWidgetDataPost(datasource, queryParams) {
    const api = this.dashboardsAPI.actions.getDashboardWidgetDataPost;
    return this.$$call(api, queryParams, {}, {datasource: datasource});
  }

  changeDashboardPublicState(dashboardId: string, isPublic: boolean) {
    const api = this.dashboardsAPI.actions.changeDashboardPublicState;
    return this.$$call(api, {isPublic: isPublic}, {}, {dashboardId: dashboardId});
  }

  private $$call(_apiCall, _params, _data, _options) {
    return this.$dashboards().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.dashboards')
  .service('dashboardsRequestsService', DashboardsRequestsService);
